// extracted by mini-css-extract-plugin
module.exports = {"slide":"TestimonialSlide_slide__irBFU","textContent":"TestimonialSlide_textContent__gV-rI"};